import api from './api'

export interface Position {
  id: number
  name: string
}

export const positionService = {
  async getPositions(): Promise<Position[]> {
    const response = await api.get('/positions')
    return response.data?.data || []
  }
}
